import { PartnerCenterSeller } from "../../../models/ticketing";

export const sellerHasGdkSwRole = (seller: PartnerCenterSeller): boolean =>
  seller.roles?.includes("Dev-Game-Platform-GDK_SW") ?? false;
